import React, { FC } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import { Auth } from './auth'
import { Invite } from './invite'
import { Room } from "./room";
import { Kifu } from "./kifu";
import { Live } from "./live";

const App: FC = () => {
  return(
    <Router>
      <Switch>
        <Route exact path="/" component={Auth} />
        <Route path="/invite/:id" component={Invite} />
        <Route path="/room/:id" component={Room} />
        <Route path="/kifu/:id" component={Kifu}/>
        <Route path="/live/:id" component={Live}/>
      </Switch>
    </Router>
  );
}

ReactDOM.render(
  <App />,
  document.getElementById('root')
);
